import styled from 'styled-components';
import { Card } from 'antd';

export const ContainerCard = styled(Card)`
  &&& {
    background-color: ${(props) => {
      if (props.styleConfig && !props.styleConfig.alternatingBg)
        return props.theme.backgroundColor.layoutLight;
      return props.cardParity % 2 === 0
        ? props.theme.backgroundColor.cardDark
        : props.theme.backgroundColor.layoutLight;
    }};
    margin-bottom: ${(props) =>
      props.styleConfig && props.styleConfig.marginBottom ? '1rem' : '0rem'};
    .ant-card-body {
      padding-top: 0;
      padding-bottom: 0;
      padding-left: ${(props) =>
        props.styleConfig && props.styleConfig.cardPadding === true
          ? '20px'
          : '0px'};
      padding-right: ${(props) =>
        props.styleConfig && props.styleConfig.cardPadding === true
          ? '20px'
          : '0px'};
    }
  }
`;

export const FlowCardGrid = styled(Card.Grid)`
  &&& {
    box-shadow: none;
    display: inline-block;
    vertical-align: top;
    float: none;
    padding-left: ${(props) =>
      props.cardDetail && props.cardDetail.pleft ? '0.5rem' : '0rem'};
    padding-right: ${(props) =>
      props.cardDetail && props.cardDetail.pright ? '0.5rem' : '0rem'};
    padding-top: ${(props) =>
      props.cardDetail && props.cardDetail.ptop ? '1.25rem' : '0rem'};
    padding-bottom: ${(props) =>
      props.cardDetail && props.cardDetail.pbottom ? '1.25rem' : '0rem'};
    overflow-wrap: break-word;
    box-shadow: ${(props) =>
      props.borderNone ? 'none' : 'inset 0 6px 4px -7px #9b9b9b'};
    &:nth-child(1) {
      box-shadow: none;
    }
  }
`;
